export const OBTER_PERITOS_REQUEST = 'OBTER_PERITOS_REQUEST';
export const OBTER_PERITOS_SUCCESS = 'OBTER_PERITOS_SUCCESS';
export const OBTER_REQUERIMENTOS_REQUEST = 'OBTER_REQUERIMENTOS_REQUEST';
export const OBTER_REQUERIMENTOS_SUCCESS = 'OBTER_REQUERIMENTOS_SUCCESS';
export const OBTER_TODOS_FORMULARIOS_REQUEST =
  'OBTER_TODOS_FORMULARIOS_REQUEST';
export const OBTER_TODOS_FORMULARIOS_SUCCESS =
  'OBTER_TODOS_FORMULARIOS_SUCCESS';
export const OBTER_LABEL_FORMULARIOS_SUCCESS =
  'OBTER_LABEL_FORMULARIOS_SUCCESS';
export const ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO =
  'ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO';
export const RESET_REQUERIMENTOS = 'RESET_REQUERIMENTOS';
